<template>

    <div id="login-page" class="form">

        <div id="card-alert" class="card green" v-if="mensagemSucesso" @click="close" data-dismiss="alert"
            aria-label="Close">
            <div class="card-content white-text">
                {{ mensagemSucesso }}
            </div>
        </div>
        <div id="card-alert"
            class="card red-light"
            v-if="mensagemErro"
            @click="close"
            data-dismiss="alert"
                aria-label="Close">
            <div class="card-content white-text">
                {{ mensagemErro }}
            </div>
        </div>

        <form class="login-form" @submit.prevent="lembrar_senha">
            <div class="mb-4">
                <small>
                    Por favor, entre com seu usuário para receber instruções de como recuperar sua senha.
                </small>
            </div>
            <div>
                <label for="username">Usuário</label>
                <input class="input" id="username" type="text" v-model="username" placeholder="Digite o seu usuário" />
            </div>
            <div>
                <button type="submit" class="button" :disabled="!username">
                    {{ carregando === false ? 'Recuperar senha' : 'Enviando...' }}
                </button>
            </div>
            <div class="mt-4 center-align">
                <router-link :to="{name: 'login'}">Acessar minha conta</router-link>
            </div>
        </form>
    </div>
</template>

<script>
    import {
        api
    } from '@/helpers/api';
    export default {
        name: "LembrarSenha",

        data() {
            return {
                username: '',
                mensagemErro: '',
                mensagemSucesso: '',
                carregando: false
            }
        },

        methods: {

            close() {
                this.erro = false;
            },

            lembrar_senha() {

                this.carregando = true;

                this.mensagemErro = null;
                this.mensagemSucesso = null;

                api.post(`recuperacao-senha`, {
                    usuario_username: this.username
                }, {
                    disableInterceptor: true
                }).then((res) => {
                    this.mensagemSucesso = res.data.statusMessage
                    this.carregando = false
                }).catch((err) => {

                    this.carregando = false

                    if (err.response.status === 422) {

                        var key = Object.keys(err.response.data.errors)[0];

                        this.mensagemErro = err.response.data.errors[key][0];

                    } else {

                        this.mensagemErro = err.response.data.statusMessage
                    }

                    return false
                })

            }
        }

    }
</script>

<style lang="scss" scoped>
h5{
    margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/auth/SolicitarRecuperacaoSenha.vue